import { pluralize } from "@/helpers/pluralize";
interface FolderContentsCount {
  descendant_file_count?: number;
  descendant_folder_count?: number;
}

export const formatFolderContentsCount = (folder: FolderContentsCount): string | null => {
  const fileCount = folder.descendant_file_count;
  const folderCount = folder.descendant_folder_count;

  if (fileCount === undefined || folderCount === undefined) {
    return null;
  }

  if (fileCount === 0 && folderCount === 0) {
    return "Empty";
  }

  return `${pluralize(fileCount, "file", "files")} · ${pluralize(folderCount, "folder", "folders")}`;
};

export const formatFolderContentsTotal = (folder: FolderContentsCount): string | null => {
  const count = formatFolderContentsCount(folder);

  if (!count || count === "Empty") {
    return count;
  }

  return `${count} total`;
};
